import { openBlock as nr, createElementBlock as ur, toDisplayString as or, ref as ar, computed as ir } from "vue";
const Yr = () => "github - hello world !!!";
function Br(e, r) {
  return e + r;
}
function Wr(e, r) {
  return e - r;
}
const zr = (e) => e - 10;
async function Vr() {
  const { data: e, pending: r, error: t } = await useAsyncData(
    "sample",
    () => new Promise((n) => {
      n("Hello, world!");
    }),
    {
      default: () => "loading..."
    }
  );
  return { data: e, pending: r, error: t };
}
const Xr = {
  __name: "Sample",
  props: {
    who: {
      type: String,
      default: "world",
      required: !1
    }
  },
  setup(e) {
    return (r, t) => (nr(), ur("h1", null, "Hello " + or(e.who), 1));
  }
}, D = {
  isShowLoading: !0
}, sr = (e, r) => {
  const { isShowLoading: t } = r, n = {
    isShowLoading: typeof t == "boolean" ? t : D.isShowLoading
  };
  return Object.assign(D, n);
}, y = ar(/* @__PURE__ */ new Set([])), cr = ir(() => y.value.size > 0), fr = () => ({
  // isLoading: computed(() => isLoading.value),
  addApiName: (e) => {
    y.value instanceof Set || (y.value = /* @__PURE__ */ new Set()), y.value = new Set(y.value).add(e);
  },
  delApiName: (e) => {
    const r = new Set(y.value);
    r.delete(e), y.value = r;
  },
  isLoading: cr
}), Gr = (e, r, t) => {
  if (!e || typeof e != "string")
    throw new Error(`apiName must be a string.  current apiName: ${e}`);
  const { addApiName: n, delApiName: u } = fr(), o = sr(D, t);
  return o.isShowLoading && n(e), r().finally(() => {
    o.isShowLoading && u(e);
  });
};
function lr(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function v(e, r, t) {
  return r = g(r), hr(e, M() ? Reflect.construct(r, t || [], g(e).constructor) : r.apply(e, t));
}
function w(e, r) {
  if (!(e instanceof r)) throw new TypeError("Cannot call a class as a function");
}
function pr(e, r, t) {
  if (M()) return Reflect.construct.apply(null, arguments);
  var n = [null];
  n.push.apply(n, r);
  var u = new (e.bind.apply(e, n))();
  return t && m(u, t.prototype), u;
}
function S(e, r, t) {
  return Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function g(e) {
  return g = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, g(e);
}
function A(e, r) {
  if (typeof r != "function" && r !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), r && m(e, r);
}
function yr(e) {
  try {
    return Function.toString.call(e).indexOf("[native code]") !== -1;
  } catch {
    return typeof e == "function";
  }
}
function M() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (M = function() {
    return !!e;
  })();
}
function hr(e, r) {
  if (r && (typeof r == "object" || typeof r == "function")) return r;
  if (r !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return lr(e);
}
function m(e, r) {
  return m = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, n) {
    return t.__proto__ = n, t;
  }, m(e, r);
}
function h(e) {
  "@babel/helpers - typeof";
  return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, h(e);
}
function F(e) {
  var r = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return F = function(t) {
    if (t === null || !yr(t)) return t;
    if (typeof t != "function") throw new TypeError("Super expression must either be null or a function");
    if (r !== void 0) {
      if (r.has(t)) return r.get(t);
      r.set(t, n);
    }
    function n() {
      return pr(t, arguments, g(this).constructor);
    }
    return n.prototype = Object.create(t.prototype, {
      constructor: {
        value: n,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), m(n, t);
  }, F(e);
}
var p = {
  NOT_FOUND: 404,
  // SERVER_ERROR: 500,
  TEMPERARY_ERROR: 500
}, b = {
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
  DATA_PARSE_ERROR: 601
}, E = {
  NOT_FOUND: "NOT_FOUND",
  SERVER_ERROR: "SERVER_ERROR",
  DATA_PARSE_ERROR: "DATA_PARSE_ERROR"
}, R = /* @__PURE__ */ function(e) {
  function r(t, n, u) {
    var o, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    return w(this, r), o = v(this, r, [t]), o.status = n, o.customErrorType = u, o.errorHistory = a, o;
  }
  return A(r, e), S(r);
}(/* @__PURE__ */ F(Error));
R.prototype.customErrorType = "CustomError";
function q(e, r) {
  Error.call(this, e), this.statusCode = r;
}
q.prototype = Object.create(Error.prototype);
q.prototype.constructor = q;
var T = /* @__PURE__ */ function(e) {
  function r(t) {
    return w(this, r), v(this, r, ["server error", 500, E.SERVER_ERROR, t]);
  }
  return A(r, e), S(r);
}(R);
T.prototype.customErrorType = E.SERVER_ERROR;
var P = /* @__PURE__ */ function(e) {
  function r(t) {
    return w(this, r), v(this, r, ["not found", 404, E.NOT_FOUND, t]);
  }
  return A(r, e), S(r);
}(R);
P.prototype.customErrorType = E.NOT_FOUND;
var J = /* @__PURE__ */ function(e) {
  function r(t) {
    return w(this, r), v(this, r, ["Data Parse Error", 601, t]);
  }
  return A(r, e), S(r);
}(R);
J.prototype.customErrorType = E.DATA_PARSE_ERROR;
var dr = function(r, t) {
  return r === 404 ? new P() : r === 500 ? new T() : r === 601 ? new J() : new R(t, r);
};
Promise.simple = function(e) {
  return new this.prototype.constructor(function(r) {
    r(e);
  });
};
Promise.simpleError = function(e, r) {
  return new this.prototype.constructor(function(t, n) {
    var u = dr(e, r);
    n(u);
  });
};
Promise.delay = function(e, r) {
  return new this.prototype.constructor(function(t) {
    setTimeout(function() {
      t(e());
    }, r);
  });
};
function i(e) {
  return e != null && h(e) === "object" && e["@@functional/placeholder"] === !0;
}
function c(e) {
  return function r(t) {
    return arguments.length === 0 || i(t) ? r : e.apply(this, arguments);
  };
}
function l(e) {
  return function r(t, n) {
    switch (arguments.length) {
      case 0:
        return r;
      case 1:
        return i(t) ? r : c(function(u) {
          return e(t, u);
        });
      default:
        return i(t) && i(n) ? r : i(t) ? c(function(u) {
          return e(u, n);
        }) : i(n) ? c(function(u) {
          return e(t, u);
        }) : e(t, n);
    }
  };
}
function N(e, r) {
  switch (e) {
    case 0:
      return function() {
        return r.apply(this, arguments);
      };
    case 1:
      return function(t) {
        return r.apply(this, arguments);
      };
    case 2:
      return function(t, n) {
        return r.apply(this, arguments);
      };
    case 3:
      return function(t, n, u) {
        return r.apply(this, arguments);
      };
    case 4:
      return function(t, n, u, o) {
        return r.apply(this, arguments);
      };
    case 5:
      return function(t, n, u, o, a) {
        return r.apply(this, arguments);
      };
    case 6:
      return function(t, n, u, o, a, f) {
        return r.apply(this, arguments);
      };
    case 7:
      return function(t, n, u, o, a, f, s) {
        return r.apply(this, arguments);
      };
    case 8:
      return function(t, n, u, o, a, f, s, d) {
        return r.apply(this, arguments);
      };
    case 9:
      return function(t, n, u, o, a, f, s, d, tr) {
        return r.apply(this, arguments);
      };
    case 10:
      return function(t, n, u, o, a, f, s, d, tr, Lr) {
        return r.apply(this, arguments);
      };
    default:
      throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
  }
}
function K(e, r, t) {
  return function() {
    for (var n = [], u = 0, o = e, a = 0, f = !1; a < r.length || u < arguments.length; ) {
      var s;
      a < r.length && (!i(r[a]) || u >= arguments.length) ? s = r[a] : (s = arguments[u], u += 1), n[a] = s, i(s) ? f = !0 : o -= 1, a += 1;
    }
    return !f && o <= 0 ? t.apply(this, n) : N(Math.max(0, o), K(e, n, t));
  };
}
var Q = /* @__PURE__ */ l(function(r, t) {
  return r === 1 ? c(t) : N(r, K(r, [], t));
});
function U(e) {
  return function r(t, n, u) {
    switch (arguments.length) {
      case 0:
        return r;
      case 1:
        return i(t) ? r : l(function(o, a) {
          return e(t, o, a);
        });
      case 2:
        return i(t) && i(n) ? r : i(t) ? l(function(o, a) {
          return e(o, n, a);
        }) : i(n) ? l(function(o, a) {
          return e(t, o, a);
        }) : c(function(o) {
          return e(t, n, o);
        });
      default:
        return i(t) && i(n) && i(u) ? r : i(t) && i(n) ? l(function(o, a) {
          return e(o, a, u);
        }) : i(t) && i(u) ? l(function(o, a) {
          return e(o, n, a);
        }) : i(n) && i(u) ? l(function(o, a) {
          return e(t, o, a);
        }) : i(t) ? c(function(o) {
          return e(o, n, u);
        }) : i(n) ? c(function(o) {
          return e(t, o, u);
        }) : i(u) ? c(function(o) {
          return e(t, n, o);
        }) : e(t, n, u);
    }
  };
}
var k = Array.isArray || function(r) {
  return r != null && r.length >= 0 && Object.prototype.toString.call(r) === "[object Array]";
};
function H(e) {
  for (var r = [], t; !(t = e.next()).done; )
    r.push(t.value);
  return r;
}
function Y(e, r, t) {
  for (var n = 0, u = t.length; n < u; ) {
    if (e(r, t[n]))
      return !0;
    n += 1;
  }
  return !1;
}
function gr(e) {
  var r = String(e).match(/^function (\w*)/);
  return r == null ? "" : r[1];
}
function _(e, r) {
  return Object.prototype.hasOwnProperty.call(r, e);
}
function mr(e, r) {
  return e === r ? e !== 0 || 1 / e === 1 / r : e !== e && r !== r;
}
var C = typeof Object.is == "function" ? Object.is : mr, B = Object.prototype.toString, Er = /* @__PURE__ */ function() {
  return B.call(arguments) === "[object Arguments]" ? function(r) {
    return B.call(r) === "[object Arguments]";
  } : function(r) {
    return _("callee", r);
  };
}(), Rr = !/* @__PURE__ */ {
  toString: null
}.propertyIsEnumerable("toString"), W = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"], z = /* @__PURE__ */ function() {
  return arguments.propertyIsEnumerable("length");
}(), Or = function(r, t) {
  for (var n = 0; n < r.length; ) {
    if (r[n] === t)
      return !0;
    n += 1;
  }
  return !1;
}, V = /* @__PURE__ */ c(typeof Object.keys == "function" && !z ? function(r) {
  return Object(r) !== r ? [] : Object.keys(r);
} : function(r) {
  if (Object(r) !== r)
    return [];
  var t, n, u = [], o = z && Er(r);
  for (t in r)
    _(t, r) && (!o || t !== "length") && (u[u.length] = t);
  if (Rr)
    for (n = W.length - 1; n >= 0; )
      t = W[n], _(t, r) && !Or(u, t) && (u[u.length] = t), n -= 1;
  return u;
}), X = /* @__PURE__ */ c(function(r) {
  return r === null ? "Null" : r === void 0 ? "Undefined" : Object.prototype.toString.call(r).slice(8, -1);
});
function G(e, r, t, n) {
  var u = H(e), o = H(r);
  function a(f, s) {
    return I(f, s, t.slice(), n.slice());
  }
  return !Y(function(f, s) {
    return !Y(a, s, f);
  }, o, u);
}
function I(e, r, t, n) {
  if (C(e, r))
    return !0;
  var u = X(e);
  if (u !== X(r))
    return !1;
  if (typeof e["fantasy-land/equals"] == "function" || typeof r["fantasy-land/equals"] == "function")
    return typeof e["fantasy-land/equals"] == "function" && e["fantasy-land/equals"](r) && typeof r["fantasy-land/equals"] == "function" && r["fantasy-land/equals"](e);
  if (typeof e.equals == "function" || typeof r.equals == "function")
    return typeof e.equals == "function" && e.equals(r) && typeof r.equals == "function" && r.equals(e);
  switch (u) {
    case "Arguments":
    case "Array":
    case "Object":
      if (typeof e.constructor == "function" && gr(e.constructor) === "Promise")
        return e === r;
      break;
    case "Boolean":
    case "Number":
    case "String":
      if (!(h(e) === h(r) && C(e.valueOf(), r.valueOf())))
        return !1;
      break;
    case "Date":
      if (!C(e.valueOf(), r.valueOf()))
        return !1;
      break;
    case "Error":
      return e.name === r.name && e.message === r.message;
    case "RegExp":
      if (!(e.source === r.source && e.global === r.global && e.ignoreCase === r.ignoreCase && e.multiline === r.multiline && e.sticky === r.sticky && e.unicode === r.unicode))
        return !1;
      break;
  }
  for (var o = t.length - 1; o >= 0; ) {
    if (t[o] === e)
      return n[o] === r;
    o -= 1;
  }
  switch (u) {
    case "Map":
      return e.size !== r.size ? !1 : G(e.entries(), r.entries(), t.concat([e]), n.concat([r]));
    case "Set":
      return e.size !== r.size ? !1 : G(e.values(), r.values(), t.concat([e]), n.concat([r]));
    case "Arguments":
    case "Array":
    case "Object":
    case "Boolean":
    case "Number":
    case "String":
    case "Date":
    case "Error":
    case "RegExp":
    case "Int8Array":
    case "Uint8Array":
    case "Uint8ClampedArray":
    case "Int16Array":
    case "Uint16Array":
    case "Int32Array":
    case "Uint32Array":
    case "Float32Array":
    case "Float64Array":
    case "ArrayBuffer":
      break;
    default:
      return !1;
  }
  var a = V(e);
  if (a.length !== V(r).length)
    return !1;
  var f = t.concat([e]), s = n.concat([r]);
  for (o = a.length - 1; o >= 0; ) {
    var d = a[o];
    if (!(_(d, r) && I(r[d], e[d], f, s)))
      return !1;
    o -= 1;
  }
  return !0;
}
var Z = /* @__PURE__ */ l(function(r, t) {
  return I(r, t, [], []);
});
function _r(e, r, t) {
  var n, u;
  if (typeof e.indexOf == "function")
    switch (h(r)) {
      case "number":
        if (r === 0) {
          for (n = 1 / r; t < e.length; ) {
            if (u = e[t], u === 0 && 1 / u === n)
              return t;
            t += 1;
          }
          return -1;
        } else if (r !== r) {
          for (; t < e.length; ) {
            if (u = e[t], typeof u == "number" && u !== u)
              return t;
            t += 1;
          }
          return -1;
        }
        return e.indexOf(r, t);
      case "string":
      case "boolean":
      case "function":
      case "undefined":
        return e.indexOf(r, t);
      case "object":
        if (r === null)
          return e.indexOf(r, t);
    }
  for (; t < e.length; ) {
    if (Z(e[t], r))
      return t;
    t += 1;
  }
  return -1;
}
function vr(e) {
  return Object.prototype.toString.call(e) === "[object String]";
}
var wr = /* @__PURE__ */ c(function(r) {
  return k(r) ? !0 : !r || h(r) !== "object" || vr(r) ? !1 : r.length === 0 ? !0 : r.length > 0 ? r.hasOwnProperty(0) && r.hasOwnProperty(r.length - 1) : !1;
}), $ = typeof Symbol < "u" ? Symbol.iterator : "@@iterator";
function Sr(e, r, t) {
  return function(u, o, a) {
    if (wr(a))
      return e(u, o, a);
    if (a == null)
      return o;
    if (typeof a["fantasy-land/reduce"] == "function")
      return r(u, o, a, "fantasy-land/reduce");
    if (a[$] != null)
      return t(u, o, a[$]());
    if (typeof a.next == "function")
      return t(u, o, a);
    if (typeof a.reduce == "function")
      return r(u, o, a, "reduce");
    throw new TypeError("reduce: list must be array or iterable");
  };
}
function Ar(e, r, t) {
  for (var n = 0, u = t.length; n < u; ) {
    if (r = e["@@transducer/step"](r, t[n]), r && r["@@transducer/reduced"]) {
      r = r["@@transducer/value"];
      break;
    }
    n += 1;
  }
  return e["@@transducer/result"](r);
}
var Tr = /* @__PURE__ */ l(function(r, t) {
  return N(r.length, function() {
    return r.apply(t, arguments);
  });
});
function Pr(e, r, t) {
  for (var n = t.next(); !n.done; ) {
    if (r = e["@@transducer/step"](r, n.value), r && r["@@transducer/reduced"]) {
      r = r["@@transducer/value"];
      break;
    }
    n = t.next();
  }
  return e["@@transducer/result"](r);
}
function Nr(e, r, t, n) {
  return e["@@transducer/result"](t[n](Tr(e["@@transducer/step"], e), r));
}
var br = /* @__PURE__ */ Sr(Ar, Nr, Pr), Cr = /* @__PURE__ */ function() {
  function e(r) {
    this.f = r;
  }
  return e.prototype["@@transducer/init"] = function() {
    throw new Error("init not implemented on XWrap");
  }, e.prototype["@@transducer/result"] = function(r) {
    return r;
  }, e.prototype["@@transducer/step"] = function(r, t) {
    return this.f(r, t);
  }, e;
}();
function jr(e) {
  return new Cr(e);
}
var L = /* @__PURE__ */ U(function(e, r, t) {
  return br(typeof e == "function" ? jr(e) : e, r, t);
}), rr = /* @__PURE__ */ c(function(r) {
  return Q(r.length, r);
});
function Dr(e, r) {
  return function() {
    return r.call(this, e.apply(this, arguments));
  };
}
function er(e, r) {
  return function() {
    var t = arguments.length;
    if (t === 0)
      return r();
    var n = arguments[t - 1];
    return k(n) || typeof n[e] != "function" ? r.apply(this, arguments) : n[e].apply(n, Array.prototype.slice.call(arguments, 0, t - 1));
  };
}
var O = /* @__PURE__ */ U(/* @__PURE__ */ er("slice", function(r, t, n) {
  return Array.prototype.slice.call(n, r, t);
})), Fr = /* @__PURE__ */ c(/* @__PURE__ */ er("tail", /* @__PURE__ */ O(1, 1 / 0)));
function qr() {
  if (arguments.length === 0)
    throw new Error("pipe requires at least one argument");
  return N(arguments[0].length, L(Dr, arguments[0], Fr(arguments)));
}
var Mr = /* @__PURE__ */ U(function(r, t, n) {
  return Q(Math.max(r.length, t.length, n.length), function() {
    return r.apply(this, arguments) ? t.apply(this, arguments) : n.apply(this, arguments);
  });
}), x = /* @__PURE__ */ l(function(r, t) {
  return typeof t.indexOf == "function" && !k(t) ? t.indexOf(r) : _r(t, r, 0);
}), Ur = function(r) {
  return L(
    function(t, n) {
      var u = n.customErrorType, o = n.handlerError;
      return function(a) {
        return t(a) ? !0 : a instanceof u ? (o(), !0) : !1;
      };
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function(t) {
      return console.log("init error handler function"), !1;
    },
    r
  );
}, kr = function(r) {
  return L(
    function(t, n) {
      var u = n.statusCode, o = n.handlerError;
      return function(a) {
        return t(a) ? !0 : u === a ? (o(), !0) : !1;
      };
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function(t) {
      return console.log("init error handler function"), !1;
    },
    r
  );
};
const Ir = rr((e = !0, r, t) => {
  if (!e) {
    const n = r.toLowerCase(), u = t.toLowerCase();
    return x(n, u);
  }
  return x(r, t);
});
rr((e, r) => e === "" ? [r, "", ""] : qr(
  // (input: string) => input.indexOf(word), // Find the index of the word in the string
  (t) => Ir(!1, e, t),
  Mr(
    Z(-1),
    // If the word is not found
    () => [r, "", ""],
    // Return the original string as the first part and empty strings
    (t) => [
      O(0, t, r),
      // First part (before the word)
      O(t, t + e.length, r),
      // The word itself
      O(t + e.length, 1 / 0, r)
      // Remaining part (after the word)
    ]
  )
)(r));
const $r = (e) => {
  Ur([
    {
      customErrorType: P,
      handlerError: () => showError({ statusCode: 404 })
    },
    {
      customErrorType: T,
      handlerError: () => showError({ statusCode: 500 })
    }
  ])(e);
}, j = (e) => {
  throw e === p.NOT_FOUND ? createError({
    statusCode: p.NOT_FOUND,
    statusMessage: "Page Not Found"
  }) : e === p.TEMPERARY_ERROR ? createError({
    statusCode: p.TEMPERARY_ERROR,
    statusMessage: "TEMPERARY_ERROR"
  }) : createError({
    statusCode: p.TEMPERARY_ERROR,
    statusMessage: "NOT DEFIEND ERROR PAGE STATUS, status: " + e
  });
}, xr = (e) => {
  kr([
    {
      statusCode: b.NOT_FOUND,
      handlerError: () => {
        j(p.NOT_FOUND);
      }
    },
    {
      statusCode: b.SERVER_ERROR,
      handlerError: () => {
        j(p.TEMPERARY_ERROR);
      }
    },
    {
      statusCode: b.DATA_PARSE_ERROR,
      handlerError: () => {
        j(p.TEMPERARY_ERROR);
      }
    }
  ])(e);
}, Jr = (e) => {
  const { response: r } = e, { status: t, data: n } = r;
  if (t === 404)
    throw new P();
  if (t === 500)
    throw new T();
};
export {
  Xr as SampleComponent,
  Br as add,
  $r as errorCatchHandlerCommon,
  xr as errorPageHandlerCommon,
  Jr as handlerInteceptorResoponseErrorCommon,
  Yr as helloWorld,
  Wr as minus,
  zr as minus10,
  j as showErrorPage,
  Gr as useApi,
  Vr as useFetchSample,
  fr as useLoading
};
//# sourceMappingURL=index.esm.js.map
